/* __next_internal_client_entry_do_not_use__ SDUIColumnSectionRenderer auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SDUIComponentRenderer } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIComponentRenderer/SDUIComponentRenderer";
import { SDUISectionStyleWrapper } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUISectionRenderer/SDUISectionStyleWrapper/SDUISectionStyleWrapper";
import { Column } from "@faire/web--source/slate/Layout";
import React from "react";
export var SDUIColumnSectionRenderer = function(param) {
    var section = param.section, componentRenderers = param.componentRenderers, sectionLoggingData = param.sectionLoggingData, loadTimingRef = param.loadTimingRef, UPLTprops = param.UPLTprops, shouldRenderBelowTheFold = param.shouldRenderBelowTheFold, onClickClientDismissHandler = param.onClickClientDismissHandler;
    var _section_column_section;
    var columnSection = section.column_section;
    if (!columnSection) {
        return null;
    }
    var containSecondaryContent = ((_section_column_section = section.column_section) === null || _section_column_section === void 0 ? void 0 : _section_column_section.components.find(function(component) {
        return component.is_required_for_interactivity !== true;
    })) !== undefined;
    return /*#__PURE__*/ _jsx(SDUISectionStyleWrapper, {
        sectionStyles: section.style,
        children: /*#__PURE__*/ _jsxs(Column, {
            className: "w-full",
            children: [
                columnSection.components.map(function(component) {
                    var isPrimaryContent = component.is_required_for_interactivity === true;
                    if (!shouldRenderBelowTheFold && !isPrimaryContent) {
                        return null;
                    }
                    return /*#__PURE__*/ _jsx(SDUIComponentRenderer, {
                        component: component,
                        componentRenderers: componentRenderers,
                        sectionLoggingParams: sectionLoggingData,
                        isPrimaryContent: isPrimaryContent,
                        loadTimingRef: loadTimingRef,
                        onClickClientDismissHandler: onClickClientDismissHandler
                    }, component.id);
                }),
                !shouldRenderBelowTheFold && containSecondaryContent ? UPLTprops === null || UPLTprops === void 0 ? void 0 : UPLTprops.belowTheFoldLoadingSkeleton : null
            ]
        })
    });
};
